/**
 * DataLayer component that renders a Geojson layer with the passed data and styles.
 */

import React from 'react';
import { GeoJson as LeafletGeojson } from 'react-leaflet';
import wrapDataLayer from './Utils/Wrapper';

const geojsonDefaultStyle = {
  fill: false,
  color: '#ff5050',
  weight: 2,
  opacity: 0.5
};

const GeojsonLayer = props => {
  const { config } = props;
  return (
    <LeafletGeojson
      data={config.data}
      style={config.style || geojsonDefaultStyle}
    />
  );
};

export { GeojsonLayer as GeojsonLayerRaw };
export default wrapDataLayer(GeojsonLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/GeojsonLayer.js
 **/